import React from 'react'
import { Button, Flex, Icon, Text } from '@workwhile/ui'
import { ExternalLinkIcon } from 'lucide-react'
import { formatInTimeZone } from 'date-fns-tz'
import { getLocalTimezone } from 'lib/time'

const INDEED_FLEX_AGENCY_BASE_URL = 'https://agency.indeedflex.com'
const IF_TIMESHEET_DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX"

function buildIndeedFlexTimesheetUrl({
  ifJobId,
  startTime,
  endTime,
}: {
  ifJobId: number
  startTime: string
  endTime: string
}): string {
  const userTimezone = getLocalTimezone()
  const params = new URLSearchParams({
    jobId: ifJobId.toString(),
    startDate: formatInTimeZone(
      startTime,
      userTimezone,
      IF_TIMESHEET_DATETIME_FORMAT
    ),
    endDate: formatInTimeZone(
      endTime,
      userTimezone,
      IF_TIMESHEET_DATETIME_FORMAT
    ),
  })

  return `${INDEED_FLEX_AGENCY_BASE_URL}/o/timesheets?${params.toString()}`
}

type ViewIndeedFlexTimesheetButtonProps = {
  ifJobId: number
  startTime: string
  endTime: string
}

export const ViewIndeedFlexTimesheetButton = ({
  ifJobId,
  startTime,
  endTime,
}: ViewIndeedFlexTimesheetButtonProps) => (
  <Button
    kind="small"
    variant="secondary"
    as="a"
    href={buildIndeedFlexTimesheetUrl({ ifJobId, startTime, endTime })}
    target="_blank"
    rel="noopener noreferrer"
    style={{ padding: '0 0.5rem', textDecoration: 'none' }}
  >
    <Flex alignItems="center" gap={1}>
      <Text fontSize="12px">Open IF timesheet</Text>
      <Icon icon={ExternalLinkIcon} size={12} />
    </Flex>
  </Button>
)
